<template>
  <div class="row m-0 h-100 align-items-center">
    <div class="col-12">
      <div class="row m-0 justify-content-center">
        <div class="col-12">
          <center>
            <h1><span class="gradient">TIME'S UP!</span></h1>
          </center>
        </div>
        <div class="col-1 mt-4 mb-4 pt-1 pl-0 pr-0">
          <div class="border_gradient"></div>
        </div>
        <div class="col-12 mt-2">
          <center>
            <h3><span class="gradient">BETTER LUCK NEXT TIME</span></h3>
          </center>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'TimesUp',
  created () {
    let vm = this
    var timeleft = 10
    var downloadTimer = setInterval(function () {
      --timeleft
      if (timeleft <= 0) {
        clearInterval(downloadTimer)
        vm.$router.push('/leaderboard')
      }
    }, 1000)
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.border_gradient {
  background: -webkit-linear-gradient(0deg, rgb(0, 75, 141) 0%, rgb(185, 140, 96) 75%);
  padding: 1px 0;
}
</style>



// WEBPACK FOOTER //
// src/components/TimesUp.vue